module.exports = __webpack_public_path__ + "img/icon_wy14.0a0d27d0.png";